import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.i3z_1 = sink;
        this.j3z_1 = false;
        this.k3z_1 = new (Buffer())();
      }
      z3u(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.j3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.k3z_1.z3u(source, byteCount);
        this.l3z();
        return Unit_instance;
      }
      p3y(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.j3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.k3z_1.p3y(byteString);
        return this.l3z();
      }
      r3y(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.j3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.k3z_1.r3y(string);
        return this.l3z();
      }
      s3y(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.j3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.k3z_1.s3y(string, beginIndex, endIndex);
        return this.l3z();
      }
      t3y(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.j3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.k3z_1.t3y(b);
        return this.l3z();
      }
      l3z() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.j3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.k3z_1.a3y();
        if (byteCount > 0n) {
          this.i3z_1.z3u(this.k3z_1, byteCount);
        }
        return this;
      }
      lc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.j3z_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.k3z_1.b3v_1 > 0n) {
          this.i3z_1.z3u(this.k3z_1, this.k3z_1.b3v_1);
        }
        this.i3z_1.lc();
        return Unit_instance;
      }
      l6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.j3z_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.k3z_1.b3v_1 > 0n) {
              this.i3z_1.z3u(this.k3z_1, this.k3z_1.b3v_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.i3z_1.l6();
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p;
            }
          }
          this.j3z_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.i3z_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
